/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownPreDepartureEventStatus } from '../models/db_DropdownPreDepartureEventStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PreDepartureEventStatuses {
    /**
     * Get a list of pre-departure event statuses
     * @returns db_DropdownPreDepartureEventStatus OK
     * @throws ApiError
     */
    public static listPreDepartureEventStatuses(): CancelablePromise<Array<db_DropdownPreDepartureEventStatus>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/pre-departure-event-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
